/* Sultan Noten — product page (sections/sn-main-product.liquid)
   - variant tiles  -> updates hidden variant id, price, button, SKU, URL
   - gallery        -> scroll-snap slider with thumbnails and arrows
   - quantity       -> +/- stepper, button total = unit price x quantity
   - cart drawer    -> opens after a successful add to cart
   Adding to cart itself is handled by the theme's own <product-form> element. */
(function () {
  document.querySelectorAll('[data-sn-pdp]').forEach(init);

  /* "€78,95" x 3 -> "€236,85" (same symbol placement, comma decimals, dot thousands) */
  function multiplyMoney(formatted, qty) {
    var m = String(formatted).match(/^([^\d]*)([\d.,\s  ']+)(.*)$/);
    if (!m) return formatted;
    var digits = m[2].replace(/\D/g, '');
    if (!digits) return formatted;
    var cents = parseInt(digits, 10) * qty;
    var whole = Math.floor(cents / 100);
    var frac = String(cents % 100);
    if (frac.length < 2) frac = '0' + frac;
    var wholeStr = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return m[1] + wholeStr + ',' + frac + m[3];
  }

  function init(root) {
    var dataEl = root.querySelector('[data-sn-product-json]');
    var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
    var variants = data.variants || [];

    /* ---------------- cart drawer ---------------- */
    var productForm = root.querySelector('product-form');
    if (productForm) {
      productForm.addEventListener('add-to-cart', function () {
        var drawer = document.getElementById('site-cart-sidebar');
        if (drawer && typeof drawer.show === 'function' && drawer.getAttribute('aria-hidden') !== 'false') drawer.show();
      });
    }

    /* ---------------- gallery ---------------- */
    var track = root.querySelector('[data-sn-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sn-thumb]'));
    var prev = root.querySelector('[data-sn-prev]');
    var next = root.querySelector('[data-sn-next]');
    var current = 0;

    function goTo(index, smooth) {
      if (!track || !slides.length) return;
      index = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(index);
    }
    function setActive(index) {
      current = index;
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (prev) prev.hidden = index === 0;
      if (next) next.hidden = index === slides.length - 1;
      var activeThumb = thumbs[index];
      if (activeThumb && activeThumb.parentElement) {
        var strip = activeThumb.parentElement;
        var left = activeThumb.offsetLeft - strip.offsetLeft;
        if (left < strip.scrollLeft || left + activeThumb.offsetWidth > strip.scrollLeft + strip.clientWidth) {
          strip.scrollTo({ left: left - 8, behavior: 'smooth' });
        }
      }
    }
    if (track) {
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== current) setActive(i);
        });
      }, { passive: true });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    setActive(0);

    /* ---------------- variants + quantity ---------------- */
    var idInput = root.querySelector('[data-sn-variant-input]');
    var atc = root.querySelector('[data-sn-atc]');
    var atcText = root.querySelector('[data-sn-atc-text]');
    var priceBox = root.querySelector('[data-sn-price]');
    var skuEl = root.querySelector('[data-sn-sku]');
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-sn-option]'));
    var qty = root.querySelector('[data-sn-qty-input]');
    var activeVariant = null;
    if (idInput) {
      for (var k = 0; k < variants.length; k++) {
        if (String(variants[k].id) === String(idInput.value)) { activeVariant = variants[k]; break; }
      }
    }

    function quantity() {
      return Math.max(1, parseInt(qty && qty.value, 10) || 1);
    }
    function renderButton() {
      if (!atcText || !activeVariant) return;
      atcText.textContent = activeVariant.available
        ? data.add_label + ' – ' + multiplyMoney(activeVariant.price, quantity())
        : data.soldout_label;
    }

    root.querySelectorAll('[data-sn-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qty) return;
        qty.value = Math.max(1, quantity() + parseInt(btn.getAttribute('data-sn-qty'), 10));
        renderButton();
      });
    });
    if (qty) {
      qty.addEventListener('input', renderButton);
      qty.addEventListener('change', function () { qty.value = quantity(); renderButton(); });
    }

    function selectedOptions() {
      return options.map(function (opt) {
        var sel = opt.querySelector('.sn-pdp__tile.is-selected');
        return sel ? sel.getAttribute('data-value') : null;
      });
    }
    function findVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < values.length; j++) { if (v.options[j] !== values[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function render(v) {
      if (!v) {
        activeVariant = null;
        if (atc) atc.disabled = true;
        if (atcText) atcText.textContent = data.unavailable_label;
        return;
      }
      activeVariant = v;
      if (idInput) idInput.value = v.id;
      if (atc) atc.disabled = !v.available;
      renderButton();
      if (priceBox) {
        var html = '<span class="sn-pdp__price-now' + (v.on_sale ? ' is-sale' : '') + '">' + v.price + '</span>';
        if (v.on_sale) {
          html += '<s class="sn-pdp__price-was">' + v.compare + '</s>';
          html += '<span class="sn-pdp__save">' + (data.save_template ? data.save_template.replace('#N#', v.save) : '%' + v.save + ' ' + data.save_label) + '</span>';
        }
        priceBox.innerHTML = html;
      }
      if (skuEl) {
        skuEl.textContent = v.sku || '';
        var row = skuEl.closest('li');
        if (row) row.hidden = !v.sku;
      }
      options.forEach(function (opt, i) {
        var label = opt.querySelector('[data-sn-option-value]');
        if (label) label.textContent = v.options[i];
      });
      if (v.media) {
        for (var s = 0; s < slides.length; s++) {
          if (String(slides[s].getAttribute('data-media-id')) === String(v.media)) { goTo(s); break; }
        }
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    options.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        var tile = e.target.closest('.sn-pdp__tile');
        if (!tile || !opt.contains(tile)) return;
        opt.querySelectorAll('.sn-pdp__tile').forEach(function (t) {
          t.classList.toggle('is-selected', t === tile);
          t.setAttribute('aria-checked', t === tile ? 'true' : 'false');
        });
        render(findVariant(selectedOptions()));
      });
    });

    renderButton();
  }
})();
